import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Radar } from 'lucide-react';
export function MechanismSection() {
  return <Section data-id="element-143">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-144">
        {/* Left: Visual representation of the mechanism */}
        <div className="relative aspect-square max-w-md mx-auto w-full" data-id="element-145">
          <div className="absolute inset-0 bg-tactical-surface rounded-full border border-tactical-cyan/20 flex items-center justify-center" data-id="element-146">
            {/* Concentric circles */}
            <div className="absolute inset-4 border border-tactical-cyan/10 rounded-full" data-id="element-147"></div>
            <div className="absolute inset-12 border border-tactical-cyan/10 rounded-full" data-id="element-148"></div>
            <div className="absolute inset-24 border border-tactical-cyan/20 rounded-full" data-id="element-149"></div>

            {/* Center player node */}
            <div className="w-4 h-4 bg-tactical-cyan rounded-full shadow-[0_0_15px_#22d3ee] z-10" data-id="element-150"></div>

            {/* Scanning radar */}
            <motion.div className="absolute inset-0 rounded-full border-t-2 border-tactical-cyan/50" animate={{
            rotate: 360
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-151">
              <div className="absolute top-0 left-1/2 w-1/2 h-full bg-gradient-to-r from-transparent to-tactical-cyan/20 origin-left" style={{
              clipPath: 'polygon(0 50%, 100% 0, 100% 50%)'
            }} data-id="element-152"></div>
            </motion.div>

            {/* Target nodes appearing */}
            <motion.div className="absolute top-1/4 right-1/4 w-3 h-3 bg-white rounded-full" animate={{
            opacity: [0, 1, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            times: [0, 0.1, 0.8]
          }} data-id="element-153" />
            <motion.div className="absolute bottom-1/3 left-1/4 w-3 h-3 bg-white rounded-full" animate={{
            opacity: [0, 1, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            delay: 1.5,
            times: [0, 0.1, 0.8]
          }} data-id="element-154" />
          </div>
        </div>

        {/* Right: Copy */}
        <div data-id="element-155">
          <div className="inline-flex items-center gap-2 text-tactical-cyan mb-4" data-id="element-156">
            <Radar className="w-5 h-5" data-id="element-157" />
            <span className="font-oswald tracking-widest text-sm" data-id="element-158">
              THE UNIQUE MECHANISM
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-159">
            COGNITIVE DECISION <br data-id="element-160" />
            <span className="text-tactical-cyan" data-id="element-161">MAPPING (CDM)</span>
          </h2>

          <div className="space-y-6 text-slate-300 font-inter text-lg leading-relaxed" data-id="element-162">
            <p data-id="element-163">
              The CDM framework is the{' '}
              <strong className="text-white" data-id="element-164">"Software Upgrade"</strong> for
              youth soccer.
            </p>
            <p data-id="element-165">
              Instead of reactive playing, we teach the{' '}
              <strong data-id="element-166">"Mbappé Scan"</strong>—a rhythmic, mechanical
              head-movement protocol used by the world's best strikers to
              automate field mapping.
            </p>
            <p className="p-6 bg-tactical-surface border-l-4 border-tactical-cyan rounded-r-lg" data-id="element-167">
              It teaches the brain to{' '}
              <strong className="text-tactical-cyan" data-id="element-168">"ping" the horizon</strong>{' '}
              and identify the "Green Zone" before the pass is even made.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}